import { DI } from '../../../../apps/crossword-maker/src/shared/di';
import { ICopyWordFromCrosswordBookPayload, IWordApiEntity } from '../../Api/Word';

export type TCopyWordFromCrosswordBookUseCase = {
	execute(data: ICopyWordFromCrosswordBookPayload): Promise<IWordApiEntity[]>;
};

export const CopyWordFromCrosswordBookUseCase = (): TCopyWordFromCrosswordBookUseCase => {
	const WordRepository = DI.resolve('WordRepository');

	return {
		async execute(data) {
			const result = await WordRepository.copyFromCrosswordBook(data);

			return result;
		},
	};
};
